import { GridSortModel } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../hooks/use-encounter-creation-gate";
import { VaccinesControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting: GridSortModel;
  sortBy?: string;
  searchString?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePublicVaccinesList = ({
  pagination,
  searchString,
  gridSorting,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "public-vaccines-list",
      xTENANTID,
      pageIndex,
      pageSize,
      searchString,
    ],
    enabled: !skip && enabled,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new VaccinesControllerApi(getConfigObject())
        .getAllVaccines(
          pageIndex,
          pageSize, //size
          sortBy,
          sortDirect,
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
